/* React hooks */
import { useEffect, useState } from "react";
/* Components */
import FormInputs from "../../FormInputs";
import {
    updateAgencyContact,
} from "../../../api/admin/agencyReq";
import useAuth from "../../../hooks/useAuth";
import { useLocation, useParams } from "react-router-dom";
import FormButtons from "../../../components/common/FormButtons";
import {
    checkRequiredFields,
    getDeep,
    getErrorListFromValidation, normalizeZipCode, patternListChoices,
    removeErrorList,
    validateFormInput
} from "../../../helper/tools";
import jwt_decode from "jwt-decode";
import InputFullAddress from "../../../components/common/input-layout/InputFullAddress";
import useData from "../../../hooks/useData";
import Icon from "../../../components/common/Icon";


const normalizeData = (infos) => {
    if (!infos) return { address: { country: "FR" } };

    const additionalZipcodes = infos?.additionalZipcodes || infos?.zipcodes || "";

    if (infos.address && typeof infos.address === 'object' && !Array.isArray(infos.address)) {
        return {
            ...infos,
            additionalZipcodes,
            address: {
                country: "FR",
                ...infos.address,
                addressId: infos.address.addressId || infos.addressId
            }
        };
    }

    return {
        ...infos,
        additionalZipcodes,
        address: {
            addressId: infos.addressId,
            address: infos.address,
            addressComp: infos.addressComp,
            zipcode: infos.zipcode,
            city: infos.city,
            country: infos.country || "FR",
            latitude: infos.latitude,
            longitude: infos.longitude
        }
    };
};

export default function FormAgencyContacts({ legend, setShowModal, apiAgencyContacts, apiAgencyProContacts, agencyContactInfos }) {
    const { auth } = useAuth();
    const token = auth.token;
    const decodedToken = jwt_decode(token);
    const agencyId = decodedToken?.agency;
    const { id } = useParams();
    const [values, setValues] = useState(normalizeData(agencyContactInfos));

    useEffect(() => {
        if (agencyContactInfos) {
            setValues(normalizeData(agencyContactInfos));
        }
    }, [agencyContactInfos]);
    const { pathname } = useLocation();
    const { selectedCity } = useData();

    const onChange = (e) => {
        setValues({ ...values, [e.target.name]: e.target.value })
        if (e.target.type === "checkbox") {
            setValues({ ...values, [e.target.name]: e.target.checked })
        }
        if (e.target.name === "latitude" || e.target.name === "longitude") {
            setValues({ ...values, address: { ...values?.address, [e.target.name]: e.target.value } })
        }
        validateFormInput(e)
    };

    useEffect(() => {
        if (selectedCity?.name || selectedCity?.zip) {
            setValues(prev => ({
                ...prev,
                address: {
                    ...prev?.address,
                    zipcode: selectedCity?.zip,
                    city: selectedCity?.name,
                    addressId: prev?.address?.addressId
                }
            }))
        }
    }, [selectedCity])

    const onChangeAddress = (e) => {
        setValues({ ...values, address: { ...values?.address, [e.target.name]: e.target.value } })
        validateFormInput(e)
    }

    const inputs = [
        {
            id: 6,
            name: "phone",
            type: "text",
            placeholder: "Téléphone",
            label: "Téléphone",
            pattern: patternListChoices?.phone
        },
        {
            id: 11,
            name: "mobile",
            type: "text",
            placeholder: "Téléphone mobile",
            label: "Téléphone mobile",
            pattern: patternListChoices?.phone
        },
        {
            id: 7,
            name: "email",
            type: "email",
            placeholder: "Email",
            label: "Email",
            required: true,
        },
        {
            id: 8,
            name: "website",
            type: "text",
            placeholder: "Site Internet",
            label: "Site Internet",
            pattern: patternListChoices?.url
        },
        {
            id: 12,
            name: "hasCondolenceEmail",
            type: "checkbox",
            label: "A une adresse email de condoléances",
        },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!checkRequiredFields()) {
            return;
        }
        const agency = pathname?.includes('admin') ? id : agencyId

        const addressData = {
            addressId: values?.address?.addressId,
            address: values?.address?.address,
            zipcode: normalizeZipCode(values?.address?.zipcode),
            addressComp: values?.address?.addressComp,
            city: values?.address?.city,
            country: values?.address?.country || "FR",
            latitude: values?.address?.latitude,
            longitude: values?.address?.longitude,
        };

        let body = {
            agencyId: agency,
            address: addressData,
            additionalZipcodes: values?.additionalZipcodes,
            phone: values?.phone,
            mobile: values?.mobile,
            email: values?.email,
            website: values?.website,
            hasCondolenceEmail: values?.hasCondolenceEmail || false,
            condolenceEmail: values?.condolenceEmail,
        }

        await updateAgencyContact(token, body)
            .then((response) => {
                removeErrorList()
                if (!response?.response?.data?.error) {
                    apiAgencyContacts()
                    setShowModal(false)
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    const handleRemoveModal = () => {
        setShowModal(false)
    };

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate autoComplete="on">
            <fieldset>
                {(legend !== "no-legend") && <Icon source="fa fa-envelope" span={legend} />}
                <InputFullAddress
                    countryField="country"
                    zipField="zipcode"
                    cityField="city"
                    addressField="address"
                    compField="addressComp"
                    address={values?.address?.address}
                    comp={values?.address?.addressComp}
                    city={values?.address?.city}
                    zipcode={values?.address?.zipcode}
                    country={values?.address?.country}
                    onChange={onChangeAddress}
                    type="actual"
                    required={true}
                />
                <div className="form-input">
                    <label htmlFor="latitude">Latitude</label>
                    <input id="latitude" name="latitude" type="text" placeholder="Latitude" value={values?.address?.latitude} onChange={onChangeAddress} />
                </div>
                <div className="form-input">
                    <label htmlFor="longitude">Longitude</label>
                    <input id="longitude" name="longitude" type="text" placeholder="Longitude" value={values?.address?.longitude} onChange={onChangeAddress} />
                </div>
                {inputs.map(input => (
                    <FormInputs
                        type={input.type}
                        name={input.name}
                        id={input.id}
                        label={input.label}
                        placeholder={input.placeholder}
                        value={getDeep(values, input?.name || input?.path)}
                        onChange={input.onChange || onChange}
                        required={input.required}
                        options={input.options}
                        selected={input.selected}
                        key={input.id + input.name}
                        pattern={input.pattern}
                        className={input.className}
                        defaultOpt={input.defaultOpt}
                    />
                ))}
                {(values?.hasCondolenceEmail == true || values?.hasCondolenceEmail == 1) &&
                    <div className="form-input">
                        <label>Adresse email de condoléances</label>
                        <input
                            name="condolenceEmail"
                            type="email"
                            placeholder="Email de condoléances"
                            onChange={onChange}
                            value={values?.condolenceEmail}
                        />
                    </div>
                }
                <div className="form-input zipcodes">
                    <label>Codes postaux additionnels (séparés par une virgule)</label>
                    <textarea
                        name="additionalZipcodes"
                        placeholder="Codes postaux"
                        value={values?.additionalZipcodes || ""}
                        onChange={onChange}
                    />
                </div>
                <div className="errors"></div>
            </fieldset>
            <FormButtons handleRemoveModal={handleRemoveModal} />
        </form>
    )
}
